import { useState } from "react";
import { useOptionalAuth } from "../auth.js";
import { Drawer } from "../ui/Dialog.js";
import { SelectedLessonCredit } from "./SelectedLessonCredit.js";
import { SelectedLessonCancellation } from "./SelectedLessonCancellation.js";
import { lessonSelectionAccess, type SelectedLesson } from "./selectedLessons.js";

export function SelectedLessonActions({ studentId, studentName, lessons, action, onClose, onChanged }: {
  studentId: string;
  studentName: string;
  lessons: SelectedLesson[];
  action: "credit" | "cancel";
  onClose: () => void;
  onChanged: () => void;
}) {
  const auth = useOptionalAuth();
  const access = lessonSelectionAccess(auth?.me);
  const [busy, setBusy] = useState(false);
  // Recover an unresolved action before opening a different financial action.
  const [currentAction, setCurrentAction] = useState(() => {
    try {
      const suffix = `${auth?.me?.user.id ?? "staff"}:${studentId}`;
      if (sessionStorage.getItem(`wmf:selected-lesson-credit:${suffix}`)) return "credit";
      if (sessionStorage.getItem(`wmf:selected-lesson-cancellation:${suffix}`)) return "cancel";
      return action;
    } catch { return action; }
  });
  return <Drawer title={currentAction === "credit" ? "Apply lesson credits" : "Cancel selected lessons"} eyebrow={studentName} size="large" busy={busy} onClose={onClose}>
    {!access[currentAction] ? <p>These actions are not available with your current permissions.</p> : currentAction === "credit" ?
      <SelectedLessonCredit studentId={studentId} lessons={lessons} onBusyChange={setBusy} onChanged={onChanged} onDiscard={() => setCurrentAction(action)} /> :
      <SelectedLessonCancellation studentId={studentId} lessons={lessons} onBusyChange={setBusy} onChanged={onChanged} />}
  </Drawer>;
}
